// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-dashboard {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

/* Loading and Error States */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #27ae60;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  text-align: center;
  background: #f8f9fa;
  border-radius: 10px;
  border: 2px solid #e74c3c;
  padding: 40px;
}

.error-container h2 {
  color: #e74c3c;
  margin-bottom: 15px;
}

.error-container p {
  color: #666;
  margin-bottom: 20px;
}

.error-container button {
  background: #27ae60;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.3s ease;
}

.error-container button:hover {
  background: #219a52;
}

.error-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 20px;
}

.logout-btn {
  background: #e74c3c !important;
}

.logout-btn:hover {
  background: #c0392b !important;
}

/* Search Box Enhancements */
.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-box input {
  padding-right: 40px; /* Make room for loading/clear button */
}

.search-loading {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.mini-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #27ae60;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.clear-search-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.clear-search-btn:hover {
  background: #c0392b;
}

/* Search Results Indicator */
.search-indicator {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 20px;
  font-size: 0.9rem;
}

.search-info {
  color: #495057;
}

.search-info strong {
  color: #27ae60;
  font-weight: 600;
}

.search-loading-text {
  color: #6c757d;
  font-style: italic;
}

.results-count {
  color: #6c757d;
  font-weight: 500;
}

.api-indicator {
  color: #17a2b8;
  font-size: 0.8rem;
  font-style: italic;
}

.dashboard-header {
  margin-bottom: 30px;
}

.dashboard-header h1 {
  color: #2c3e50;
  text-align: center;
  margin-bottom: 30px;
  font-size: 2.5rem;
}

.dashboard-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.dashboard-navigation {
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 0;
}

.nav-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-weight: 600;
  color: #666;
  transition: all 0.3s ease;
  font-size: 0.95rem;
}

.nav-tab:hover {
  color: #27ae60;
  background-color: #f8f9fa;
}

.nav-tab.active {
  color: #27ae60;
  border-bottom-color: #27ae60;
  background-color: #f8f9fa;
}

.dashboard-content {
  min-height: 400px;
}

.coming-soon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  font-size: 1.5rem;
  color: #666;
  background: #f8f9fa;
  border-radius: 10px;
  border: 2px dashed #ddd;
}

.stat-card {
  background: white;
  padding: 25px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #27ae60;
}

.stat-card h3 {
  color: #666;
  margin-bottom: 10px;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.stat-card p {
  color: #2c3e50;
  font-size: 2rem;
  font-weight: bold;
  margin: 0;
}

.dashboard-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  gap: 20px;
  flex-wrap: wrap;
}

.sort-controls {
  display: flex;
  gap: 10px;
  align-items: center;
}

.sort-controls select {
  padding: 10px 14px;
  border: 2px solid #e0e0e0;
  border-radius: 25px;
  background: white;
  cursor: pointer;
}

.search-box input {
  padding: 12px 20px;
  border: 2px solid #e0e0e0;
  border-radius: 25px;
  font-size: 16px;
  width: 300px;
  transition: border-color 0.3s ease;
}

.search-box input:focus {
  outline: none;
  border-color: #27ae60;
}

.filter-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.filter-buttons button {
  padding: 10px 20px;
  border: 2px solid #e0e0e0;
  background-color: white;
  border-radius: 25px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
}

.filter-buttons button:hover {
  border-color: #27ae60;
  color: #27ae60;
}

.filter-buttons button.active {
  background-color: #27ae60;
  border-color: #27ae60;
  color: white;
}

.bookings-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.booking-card {
  background: white;
  border-radius: 10px;
  padding: 25px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #3498db;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.booking-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.booking-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.booking-info h3 {
  color: #2c3e50;
  margin: 0 0 5px 0;
  font-size: 1.3rem;
}

.booking-info p {
  color: #666;
  margin: 2px 0;
  font-size: 0.9rem;
}

.status-badge {
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.booking-details {
  margin-bottom: 20px;
}

.detail-row {
  margin-bottom: 8px;
  color: #333;
  font-size: 0.95rem;
}

.detail-row strong {
  color: #2c3e50;
  margin-right: 5px;
}

.booking-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.view-details-btn {
  padding: 8px 16px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.view-details-btn:hover {
  background-color: #2980b9;
}

.status-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.confirm-btn,
.start-btn,
.complete-btn,
.cancel-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
}

.confirm-btn {
  background-color: #27ae60;
  color: white;
}

.confirm-btn:hover {
  background-color: #219a52;
}

.confirm-btn:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
  opacity: 0.6;
}

.confirm-btn:disabled:hover {
  background-color: #95a5a6;
}

.start-btn {
  background-color: #9b59b6;
  color: white;
}

.start-btn:hover {
  background-color: #8e44ad;
}

.complete-btn {
  background-color: #27ae60;
  color: white;
}

.complete-btn:hover {
  background-color: #219a52;
}

.cancel-btn {
  background-color: #e74c3c;
  color: white;
}

.cancel-btn:hover {
  background-color: #c0392b;
}

.no-bookings {
  text-align: center;
  padding: 60px 20px;
  color: #666;
  font-size: 1.2rem;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 15px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px;
  border-bottom: 2px solid #e0e0e0;
}

.modal-header h2 {
  color: #2c3e50;
  margin: 0;
  font-size: 1.5rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background-color: #f0f0f0;
  color: #333;
}

.modal-body {
  padding: 30px;
}

.detail-section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.detail-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.detail-section h3 {
  color: #2c3e50;
  margin-bottom: 15px;
  font-size: 1.2rem;
}

.detail-section p {
  margin: 8px 0;
  color: #333;
  line-height: 1.5;
}

.detail-section strong {
  color: #2c3e50;
  margin-right: 8px;
}

.photos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.photo-item {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.photo-item img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

@media (max-width: 768px) {
  .admin-dashboard {
    padding: 10px;
  }
  
  .dashboard-header h1 {
    font-size: 2rem;
  }
  
  .dashboard-stats {
    grid-template-columns: 1fr;
  }
  
  .dashboard-controls {
    flex-direction: column;
    align-items: stretch;
  }
  
  .search-box input {
    width: 100%;
  }
  
  .filter-buttons {
    justify-content: center;
  }
  
  .booking-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .booking-actions {
    flex-direction: column;
    align-items: stretch;
  }
  
  .status-actions {
    justify-content: center;
  }
  
  .modal-content {
    margin: 10px;
    max-height: 95vh;
  }
  
  .modal-header,
  .modal-body {
    padding: 20px;
  }
  
  .photos-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/admin/AdminDashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,EAAE,uCAAuC;AAC9D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;;;EAIE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,4DAA4D;EAC9D;AACF","sourcesContent":[".admin-dashboard {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: Arial, sans-serif;\n}\n\n/* Loading and Error States */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 400px;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #27ae60;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 400px;\n  text-align: center;\n  background: #f8f9fa;\n  border-radius: 10px;\n  border: 2px solid #e74c3c;\n  padding: 40px;\n}\n\n.error-container h2 {\n  color: #e74c3c;\n  margin-bottom: 15px;\n}\n\n.error-container p {\n  color: #666;\n  margin-bottom: 20px;\n}\n\n.error-container button {\n  background: #27ae60;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background 0.3s ease;\n}\n\n.error-container button:hover {\n  background: #219a52;\n}\n\n.error-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.logout-btn {\n  background: #e74c3c !important;\n}\n\n.logout-btn:hover {\n  background: #c0392b !important;\n}\n\n/* Search Box Enhancements */\n.search-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-box input {\n  padding-right: 40px; /* Make room for loading/clear button */\n}\n\n.search-loading {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.mini-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #27ae60;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.clear-search-btn {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: #e74c3c;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.3s ease;\n}\n\n.clear-search-btn:hover {\n  background: #c0392b;\n}\n\n/* Search Results Indicator */\n.search-indicator {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  font-size: 0.9rem;\n}\n\n.search-info {\n  color: #495057;\n}\n\n.search-info strong {\n  color: #27ae60;\n  font-weight: 600;\n}\n\n.search-loading-text {\n  color: #6c757d;\n  font-style: italic;\n}\n\n.results-count {\n  color: #6c757d;\n  font-weight: 500;\n}\n\n.api-indicator {\n  color: #17a2b8;\n  font-size: 0.8rem;\n  font-style: italic;\n}\n\n.dashboard-header {\n  margin-bottom: 30px;\n}\n\n.dashboard-header h1 {\n  color: #2c3e50;\n  text-align: center;\n  margin-bottom: 30px;\n  font-size: 2.5rem;\n}\n\n.dashboard-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.dashboard-navigation {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 30px;\n  border-bottom: 2px solid #e0e0e0;\n  padding-bottom: 0;\n}\n\n.nav-tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  font-weight: 600;\n  color: #666;\n  transition: all 0.3s ease;\n  font-size: 0.95rem;\n}\n\n.nav-tab:hover {\n  color: #27ae60;\n  background-color: #f8f9fa;\n}\n\n.nav-tab.active {\n  color: #27ae60;\n  border-bottom-color: #27ae60;\n  background-color: #f8f9fa;\n}\n\n.dashboard-content {\n  min-height: 400px;\n}\n\n.coming-soon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 400px;\n  font-size: 1.5rem;\n  color: #666;\n  background: #f8f9fa;\n  border-radius: 10px;\n  border: 2px dashed #ddd;\n}\n\n.stat-card {\n  background: white;\n  padding: 25px;\n  border-radius: 10px;\n  text-align: center;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  border-left: 4px solid #27ae60;\n}\n\n.stat-card h3 {\n  color: #666;\n  margin-bottom: 10px;\n  font-size: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.stat-card p {\n  color: #2c3e50;\n  font-size: 2rem;\n  font-weight: bold;\n  margin: 0;\n}\n\n.dashboard-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.sort-controls {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.sort-controls select {\n  padding: 10px 14px;\n  border: 2px solid #e0e0e0;\n  border-radius: 25px;\n  background: white;\n  cursor: pointer;\n}\n\n.search-box input {\n  padding: 12px 20px;\n  border: 2px solid #e0e0e0;\n  border-radius: 25px;\n  font-size: 16px;\n  width: 300px;\n  transition: border-color 0.3s ease;\n}\n\n.search-box input:focus {\n  outline: none;\n  border-color: #27ae60;\n}\n\n.filter-buttons {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.filter-buttons button {\n  padding: 10px 20px;\n  border: 2px solid #e0e0e0;\n  background-color: white;\n  border-radius: 25px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: all 0.3s ease;\n}\n\n.filter-buttons button:hover {\n  border-color: #27ae60;\n  color: #27ae60;\n}\n\n.filter-buttons button.active {\n  background-color: #27ae60;\n  border-color: #27ae60;\n  color: white;\n}\n\n.bookings-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.booking-card {\n  background: white;\n  border-radius: 10px;\n  padding: 25px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  border-left: 4px solid #3498db;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.booking-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.booking-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.booking-info h3 {\n  color: #2c3e50;\n  margin: 0 0 5px 0;\n  font-size: 1.3rem;\n}\n\n.booking-info p {\n  color: #666;\n  margin: 2px 0;\n  font-size: 0.9rem;\n}\n\n.status-badge {\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.booking-details {\n  margin-bottom: 20px;\n}\n\n.detail-row {\n  margin-bottom: 8px;\n  color: #333;\n  font-size: 0.95rem;\n}\n\n.detail-row strong {\n  color: #2c3e50;\n  margin-right: 5px;\n}\n\n.booking-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n.view-details-btn {\n  padding: 8px 16px;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background-color 0.3s ease;\n}\n\n.view-details-btn:hover {\n  background-color: #2980b9;\n}\n\n.status-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.confirm-btn,\n.start-btn,\n.complete-btn,\n.cancel-btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: all 0.3s ease;\n}\n\n.confirm-btn {\n  background-color: #27ae60;\n  color: white;\n}\n\n.confirm-btn:hover {\n  background-color: #219a52;\n}\n\n.confirm-btn:disabled {\n  background-color: #95a5a6;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.confirm-btn:disabled:hover {\n  background-color: #95a5a6;\n}\n\n.start-btn {\n  background-color: #9b59b6;\n  color: white;\n}\n\n.start-btn:hover {\n  background-color: #8e44ad;\n}\n\n.complete-btn {\n  background-color: #27ae60;\n  color: white;\n}\n\n.complete-btn:hover {\n  background-color: #219a52;\n}\n\n.cancel-btn {\n  background-color: #e74c3c;\n  color: white;\n}\n\n.cancel-btn:hover {\n  background-color: #c0392b;\n}\n\n.no-bookings {\n  text-align: center;\n  padding: 60px 20px;\n  color: #666;\n  font-size: 1.2rem;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 15px;\n  max-width: 800px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 25px 30px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.modal-header h2 {\n  color: #2c3e50;\n  margin: 0;\n  font-size: 1.5rem;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.close-btn:hover {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n.modal-body {\n  padding: 30px;\n}\n\n.detail-section {\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.detail-section:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.detail-section h3 {\n  color: #2c3e50;\n  margin-bottom: 15px;\n  font-size: 1.2rem;\n}\n\n.detail-section p {\n  margin: 8px 0;\n  color: #333;\n  line-height: 1.5;\n}\n\n.detail-section strong {\n  color: #2c3e50;\n  margin-right: 8px;\n}\n\n.photos-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.photo-item {\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.photo-item img {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n}\n\n@media (max-width: 768px) {\n  .admin-dashboard {\n    padding: 10px;\n  }\n  \n  .dashboard-header h1 {\n    font-size: 2rem;\n  }\n  \n  .dashboard-stats {\n    grid-template-columns: 1fr;\n  }\n  \n  .dashboard-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .search-box input {\n    width: 100%;\n  }\n  \n  .filter-buttons {\n    justify-content: center;\n  }\n  \n  .booking-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n  \n  .booking-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .status-actions {\n    justify-content: center;\n  }\n  \n  .modal-content {\n    margin: 10px;\n    max-height: 95vh;\n  }\n  \n  .modal-header,\n  .modal-body {\n    padding: 20px;\n  }\n  \n  .photos-grid {\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
